import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import { openModal } from '../../modals';
import { sortDataByCreatedAt } from '../../utils';
import LogsList from '../../components/logs-simple-list';
import { handleRequestLogDelete } from '../../redux/thunk/request-logs';
import { getAuthorizedUser, getRequestLogs } from '../../redux/selectors';


const mapStateToProps = (state, props) => ({
  authorizedUser: getAuthorizedUser(state),
  ...R.compose(
    ({ logs }) => ({
      logs: Object.values(logs),
    }),
    ({ logs }) => ({ logs: sortDataByCreatedAt(logs) }),
    data => ({ logs: getRequestLogs(data, props) }),
  )(state),
});

export default compose(
  connect(
    mapStateToProps,
    { openModal, handleRequestLogDelete },
  ),
  withHandlers({
    handleLogDelete: props => (requestLogId) => {
      props.handleRequestLogDelete(requestLogId, props.logs.length);
    },
  }),
)(LogsList);



// WEBPACK FOOTER //
// ./src/containers/request-logs-simple-list/index.js